import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-1 max-w-3xl mx-auto px-6 md:px-12 py-12" data-testid="privacy-page">
        <h1 className="text-3xl md:text-4xl font-heading font-semibold mb-2">Privacy Policy</h1>
        <p className="text-sm text-muted-foreground mb-8">Last updated: May 2, 2026</p>

        <div className="prose prose-sm max-w-none space-y-6 text-foreground/90">
          <section>
            <h2 className="text-xl font-heading font-semibold mb-2">1. Who We Are</h2>
            <p>Christ Kingdom Global Marketplace ("we", "us") is operated by Datasamllc. We respect your privacy and are committed to protecting your personal information.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold mb-2">2. Information We Collect</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Account info:</strong> name, email, password (hashed), optional phone, country</li>
              <li><strong>Vendor info:</strong> business name, description, KYC documents (Business License, Government ID)</li>
              <li><strong>Payment info:</strong> processed directly by Stripe — we never store full card numbers</li>
              <li><strong>Order history:</strong> products purchased, shipping details</li>
              <li><strong>Usage data:</strong> page views, device type, IP, for analytics</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold mb-2">3. How We Use Your Information</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>To create and maintain your account</li>
              <li>To process orders and payouts</li>
              <li>To send transactional emails (signup welcome, order confirmations, KYC approvals)</li>
              <li>To verify vendor identity (KYC)</li>
              <li>To improve and secure the Platform</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold mb-2">4. How We Share Your Information</h2>
            <p>We share data only with trusted service providers:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Stripe</strong> — for payment processing and vendor payouts</li>
              <li><strong>Resend</strong> — for transactional email delivery</li>
              <li><strong>Vendors</strong> — buyer name and shipping address are shared with vendors to fulfill orders</li>
              <li><strong>Legal authorities</strong> — when required by law</li>
            </ul>
            <p>We do <strong>not</strong> sell your personal data to third parties.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold mb-2">5. Data Security</h2>
            <p>We use industry-standard encryption (HTTPS, bcrypt for passwords, 256-bit SSL). KYC documents are stored in encrypted MongoDB GridFS. Only authorized admin personnel can access KYC documents for verification.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold mb-2">6. Your Rights</h2>
            <p>You may:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Access your account data anytime via your dashboard</li>
              <li>Update or correct your information</li>
              <li>Request deletion of your account (email support)</li>
              <li>Opt out of marketing emails (transactional emails are required)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold mb-2">7. Cookies & Tracking</h2>
            <p>We use minimal cookies for authentication (JWT tokens) and anonymous analytics (page views, unique visitors). No third-party advertising cookies.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold mb-2">8. International Transfers</h2>
            <p>Our servers may be located in the United States. By using the Platform, you consent to data being processed in the US.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold mb-2">9. Children</h2>
            <p>The Platform is not intended for anyone under 18. We do not knowingly collect data from minors.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold mb-2">10. Policy Updates</h2>
            <p>We may update this policy. The "Last updated" date at the top will reflect changes. Material changes will be emailed to you.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold mb-2">11. Contact</h2>
            <p>Questions or concerns? Email <a href="mailto:privacy@christkingdomglobalmarketplace.com" className="text-primary underline">privacy@christkingdomglobalmarketplace.com</a>.</p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
